export default __webpack_public_path__ + "static/graph-video-cbc1e042992a78e549524924f98e9313.mp4";